export default {
  MESSAGE_1:
    "Doy permiso a la instalación para que me envíe e-mails y sms promocionales",
  MESSAGE_2: "Responsabilidad condiciones físicas y estado de salud",
  MESSAGE_3:
    "He leído y acepto el aviso legal y las condiciones de la política de Protección de Datos. *",
  MESSAGE_4: "He leído y acepto términos y condiciones.*",
};
